import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function InviteColleagueModal({ event, onClose, onInvited }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [ticketId, setTicketId] = useState((event.tickets || [])[0]?.id || "");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await api.post(`/events/${event.id}/invite-colleague`, {
        first_name: firstName, last_name: lastName, email, ticket_id: ticketId,
      });
      onInvited();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erreur");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="invite-colleague-modal">
      <form onSubmit={submit} className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full hover:bg-neutral-100" aria-label="Fermer">
          <X className="h-4 w-4" />
        </button>
        <h2 className="text-lg font-bold text-navy">Inviter un collègue à {event.title}</h2>
        <p className="mt-1 text-xs text-neutral-600">Il recevra un email avec un lien pour confirmer son inscription.</p>
        <div className="mt-4 grid grid-cols-2 gap-3">
          <input type="text" placeholder="Prénom" value={firstName} onChange={(e) => setFirstName(e.target.value)} required
                 className="rounded-lg border border-neutral-300 px-3 py-2 text-sm" data-testid="invite-first-name" />
          <input type="text" placeholder="Nom" value={lastName} onChange={(e) => setLastName(e.target.value)} required
                 className="rounded-lg border border-neutral-300 px-3 py-2 text-sm" data-testid="invite-last-name" />
        </div>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required
               className="mt-3 w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm" data-testid="invite-email" />
        {(event.tickets || []).length > 0 && (
          <select value={ticketId} onChange={(e) => setTicketId(e.target.value)}
                  className="mt-3 w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm" data-testid="invite-ticket">
            {event.tickets.map((t) => (
              <option key={t.id} value={t.id}>{t.name} {t.price ? `· ${t.price}€` : "· Gratuit"}</option>
            ))}
          </select>
        )}
        <button type="submit" disabled={busy}
                className="mt-5 w-full rounded-full bg-wine-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-wine-700 disabled:opacity-50"
                data-testid="invite-submit">
          {busy ? "Envoi en cours…" : "Envoyer l'invitation"}
        </button>
      </form>
    </div>
  );
}

